// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

.form-row {
  height: 100%;
}
.form-row > ion-col {
  height: 100%;
}

.swiper-container, swiper-container {
  height: 100%;
  min-height: 0;
}

.margin-top-value {
  margin-top: 10px;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  overflow: auto;
  overflow-x: hidden;
}

.header-block {
  padding: 30px 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.header-block .header-text {
  font-family: Title;
  font-size: 32px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  vertical-align: baseline;
}
.header-block .header-text.accent {
  color: #c6a475;
}
.header-block .knife {
  height: 22px;
  width: 129px;
}

.wrapper-basket {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.wrapper-basket .article-wrappers {
  flex-grow: 1;
  padding-top: 10px;
  overflow-y: auto;
  margin: 0 18px 18px;
  background: #fff;
  border-radius: 9px;
}

.footer {
  padding-top: 10px;
  width: 100%;
}
.footer.footer-block {
  padding: 20px;
  box-shadow: 3px 0px 45px 0px rgba(0, 0, 0, 0.0705882353);
  width: 100%;
}
.footer ion-button {
  width: 100%;
  margin-bottom: 5px;
  min-height: 54px;
  font-size: 17px;
  --background: #2D69AA;
}
.footer .tips {
  border-bottom: 1px solid var(--color-black);
  padding-bottom: 10px;
}

.sub-total {
  padding: 0;
  margin-bottom: 8px;
}
.sub-total .sub-total-title,
.sub-total .sub-total-sum {
  font-family: AppFont;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 8%;
  vertical-align: middle;
  text-transform: uppercase;
}

.table-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  border-bottom: 1px solid var(--color-black);
}
.table-row .table-title,
.table-row .table-sum {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.total {
  padding: 0;
}
.total .total-title,
.total .total-sum {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.form-card {
  padding: 15px 25px;
  position: relative;
  height: auto;
  display: flex;
  flex-direction: column;
}
.form-card .cross-icon {
  z-index: 5;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  width: 25px;
  height: 25px;
  padding: 0px;
  z-index: 99;
  border: none;
}
.form-card .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.form-card .title {
  padding: 0 5px;
  font-size: 18px;
  font-family: BricolageGrotesque;
  font-weight: 700;
}
@media (min-width: 991px) {
  .form-card .title {
    margin-bottom: 30px;
  }
}
.form-card .wrapper-for-inputs {
  flex-grow: 1;
}
.form-card .footer {
  width: 100%;
}
.form-card .footer .footer-btn {
  width: 100%;
  min-height: 54px;
  --background: #2D69AA;
  font-size: 17px;
  font-family: BricolageGrotesque;
  font-weight: 700;
}
.button-row {
  padding: 10px 18px;
}

.container {
  max-height: 85px;
}

.error_container {
  height: 12px;
  position: relative;
  margin-bottom: 5px;
  margin-top: 5px;
  left: auto;
}

.input_group {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 10px;
  align-items: center;
}
.input_group--1 {
  grid-column: span 8;
}
.input_group--2 {
  grid-column: span 4;
}

.footer-block-shadow {
  box-shadow: 3px 0px 45px 0px rgba(0, 0, 0, 0.0705882353);
}

ion-label {
  font-size: 11px;
  color: #807D7D;
  font-weight: 600;
  text-transform: capitalize;
  background: #fff;
  padding: 0 5px;
}
ion-label.stacked {
  position: relative;
  top: 18px;
  left: 2%;
  z-index: 2;
}

.input {
  border-radius: 0%;
  border: 1px solid #E5E5E5;
  --background: #fff;
  --color:#313131;
}

ion-icon.select-icon {
  width: 25px;
  color: #141B34;
}

ion-datetime {
  --background: #fff;
  color: #666;
}

ion-datetime-button::part(native) {
  background-color: #fff;
  color: #313131;
  border-radius: none;
  padding: 0;
}

.reishauer-header {
  background: var(--bg-primary);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  justify-content: flex-end;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
}
.reishauer-header .logo-wrapper {
  cursor: pointer;
}
.reishauer-header .back-selector {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.info {
  border-bottom: 1px solid #DCE8F5;
  padding-bottom: 5px;
}
.info.total-block {
  margin-bottom: 30px;
}
.info .info-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}
.info .info-block p {
  font-family: BricolageGrotesque;
  color: #072633;
}
.info .info-block p.form-label {
  font-weight: 500;
  font-size: 16px;
}
.info .info-block p.form-label.total {
  font-weight: 700;
  font-size: 20px;
}
.info .info-block p.form-value {
  font-size: 14px;
  font-weight: 300;
}
.info .info-block p.form-value.total {
  font-weight: 700;
  font-size: 18px;
}

.edit-block {
  display: flex;
  align-items: end;
  gap: 12px;
  font-family: BricolageGrotesque;
  font-size: 18px;
  font-weight: 700;
  color: #072633;
}
.edit-block .checkout-edit {
  width: 24px;
  height: 24px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAGA;EACC,YAAA;AAAD;AAEC;EACC,YAAA;AAAF;;AAGA;EACC,YAAA;EACA,aAAA;AAAD;;AAEA;EACC,gBAAA;AACD;;AACA;EACC,sBAAA;EACA,uBAAA;AAED;;AACA;EACC,cAAA;EACA,kBAAA;AAED;;AACA;EACC,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAED;AAAC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;AAEF;AAAE;EACC,cAAA;AAEH;AAEC;EACC,YAAA;EACA,YAAA;AAAF;;AAIA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;AADD;AAEC;EACC,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAIA;EAEC,iBAAA;EACA,WAAA;AAFD;AAGC;EACC,aAAA;EACA,wDAAA;EACA,WAAA;AADF;AAGC;EACC,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AADF;AAGC;EACC,2CAAA;EACA,oBAAA;AADF;;AAKA;EACC,UAAA;EACA,kBAAA;AAFD;AAGC;;EAEC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AADF;;AAKA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;AAFD;AAGC;;EAEC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AADF;;AAKA;EACC,UAAA;AAFD;AAIC;;EAEC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAFF;;AAKA;EACC,kBAAA;EACA,kBAAA;EAEA,YAAA;EACA,aAAA;EACA,sBAAA;AAHD;AAIC;EACC,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,WAAA;EAEA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAJF;AAKE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAHH;AASC;EACC,cAAA;EACA,eAAA;EACA,+BAAA;EACA,gBAAA;AAPF;ACnKE;EDsKD;IAME,mBAAA;EALD;AACF;AAQC;EACC,YAAA;AANF;AAQC;EACC,WAAA;AANF;AAOE;EACC,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,+BAAA;EACA,gBAAA;AALH;AAaA;EACC,kBAAA;AAXD;;AAcA;EACC,gBAAA;AAXD;;AAcA;EACC,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AAXD;;AAcA;EACC,aAAA;EACA,sCAAA;EACA,SAAA;EACA,mBAAA;AAXD;AAaC;EACC,mBAAA;AAXF;AAcC;EACC,mBAAA;AAZF;;AAeA;EACC,wDAAA;AAZD;;AAcA;EACC,eAAA;EACG,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;AAXJ;AAYC;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AAVF;;AAaA;EACC,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAVD;;AAgBC;EACC,WAAA;EACA,cAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,WAAA;AAbF;;AAgBA;EACE,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AAbF;;AAgBA;EACC,6BAAA;EACG,iDAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAbJ;AAeC;EACC,eAAA;AAbF;AAgBC;EACC,WAAA;EACA,YAAA;EACA,eAAA;AAdF;;AAkBA;EACC,gCAAA;EACA,mBAAA;AAfD;AAgBE;EACA,mBAAA;AAdF;AAiBE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAfH;AAgBG;EACC,+BAAA;EACA,cAAA;AAdJ;AAgBI;EACC,gBAAA;EACA,eAAA;AAdL;AAgBK;EACC,gBAAA;EACA,eAAA;AAdN;AAiBI;EACC,eAAA;EACA,gBAAA;AAfL;AAiBK;EACC,gBAAA;EACA,eAAA;AAfN;;AAqBA;EACC,aAAA;EACA,gBAAA;EACA,SAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAlBD;AAoBC;EACC,WAAA;EACA,YAAA;EACA,eAAA;AAlBF","sourcesContent":["@import '../../../theme/mixins';\n\n:root {\n\t--ion-padding: 12px;\n}\n.form-row {\n\theight: 100%;\n\n\t& > ion-col {\n\t\theight: 100%;\n\t}\n}\n.swiper-container, swiper-container {\n\theight: 100%;\n\tmin-height: 0;\n}\n.margin-top-value {\n\tmargin-top: 10px;\n}\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\toverflow: auto;\n\toverflow-x: hidden;\n}\n\n.header-block {\n\tpadding: 30px 0 30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\n\t.header-text {\n\t\tfont-family: Title;\n\t\tfont-size: 32px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t\tvertical-align: baseline;\n\n\t\t&.accent {\n\t\t\tcolor: #c6a475;\n\t\t}\n\t}\n\n\t.knife {\n\t\theight: 22px;\n\t\twidth: 129px;\n\t}\n}\n\n.wrapper-basket {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\t.article-wrappers {\n\t\tflex-grow: 1;\n\t\tpadding-top: 10px;\n\t\toverflow-y: auto;\n\t\tmargin: 0 18px 18px;\n\t\tbackground: #fff;\n\t\tborder-radius: 9px;\n\t}\n}\n\n.footer {\n\t// border-top: 1px solid var(--color-black);\n\tpadding-top: 10px;\n\twidth: 100%;\n\t&.footer-block { //todo:re move duplicate\n\t\tpadding: 20px;\n\t\tbox-shadow: 3px 0px 45px 0px rgba(0, 0, 0, 0.0705882353);\n\t\twidth: 100%;\n\t}\n\tion-button {\n\t\twidth: 100%;\n\t\tmargin-bottom: 5px;\n\t\tmin-height: 54px;\n\t\tfont-size: 17px;\n\t\t--background: #2D69AA;\n\t}\n\t.tips {\n\t\tborder-bottom: 1px solid var(--color-black);\n\t\tpadding-bottom: 10px;\n\t}\n}\n\n.sub-total {\n\tpadding: 0;\n\tmargin-bottom: 8px;\n\t.sub-total-title,\n\t.sub-total-sum {\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 8%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.table-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 10px 18px;\n\tborder-bottom: 1px solid var(--color-black);\n\t.table-title,\n\t.table-sum {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.total {\n\tpadding: 0;\n\n\t.total-title,\n\t.total-sum {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n.form-card {\n\tpadding: 15px 25px;\n\tposition: relative;\n\t// height: 100%;\n\theight: auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\t.cross-icon {\n\t\tz-index: 5;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\n\t\tmargin: 0px;\n\t\t// background: var(--color-white-accent);\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tborder: none;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t&:hover {\n\t\t\t// background: #f2dbd9;\n\t\t}\n\t}\n\t.title {\n\t\tpadding: 0 5px;\n\t\tfont-size: 18px;\n\t\tfont-family: BricolageGrotesque;\n\t\tfont-weight: 700;\n\t\t@include desktop {\n\t\t\tmargin-bottom: 30px;\n\t\t}\n\t}\n\n\t.wrapper-for-inputs {\n\t\tflex-grow: 1;\n\t}\n\t.footer {\n\t\twidth: 100%;\n\t\t.footer-btn {\n\t\t\twidth: 100%;\n\t\t\tmin-height: 54px;\n\t\t\t--background: #2D69AA;\n\t\t\tfont-size: 17px;\n\t\t\tfont-family: BricolageGrotesque;\n\t\t\tfont-weight: 700;\n\t\t\t&:hover {\n\t\t\t\t// --background: var(--primary-btn) !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.button-row {\n\tpadding: 10px 18px;\n\n}\n.container {\n\tmax-height: 85px;\n}\n\n.error_container {\n\theight: 12px;\n\tposition: relative;\n\tmargin-bottom: 5px;\n\tmargin-top: 5px;\n\tleft: auto;\n}\n\n.input_group {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(12, 1fr);\n\tgap: 10px;\n\talign-items: center;\n\n\t&--1 {\n\t\tgrid-column: span 8;\n\t}\n\n\t&--2 {\n\t\tgrid-column: span 4;\n\t}\n}\n.footer-block-shadow {\n\tbox-shadow: 3px 0px 45px 0px rgba(0, 0, 0, 0.0705882353);\n}\nion-label {\n\tfont-size: 11px;\n    color: #807D7D;\n    font-weight: 600;\n    text-transform: capitalize;\n    background: #fff;\n    padding: 0 5px;\n\t&.stacked {\n\t\tposition: relative;\n\t\ttop: 18px;\n\t\tleft: 2%;\n\t\tz-index: 2;\n\t}\n}\n.input {\n\tborder-radius: 0%;\n\tborder: 1px solid #E5E5E5;\n\t--background: #fff;\n\t--color:#313131;\n\t// &:hover{\n\n\t// }\n}\nion-icon {\n\t&.select-icon {\n\t\twidth: 25px;\n\t\tcolor: #141B34;\n\t}\n}\nion-datetime {\n  --background: #fff;\n  color: #666;\n}\nion-datetime::part(calendar-day-selected) {}\nion-datetime-button::part(native) {\n  background-color: #fff;\n  color: #313131;\n  border-radius: none;\n  padding: 0;\n}\n\n.reishauer-header {\n\tbackground: var(--bg-primary);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    justify-content: flex-end;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 15px;\n\t\n\t.logo-wrapper {\n\t\tcursor: pointer;\n\t}\n\n\t.back-selector {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tcursor: pointer;\n\t}\n}\n\n.info {\n\tborder-bottom: 1px solid #DCE8F5;\n\tpadding-bottom: 5px;\n\t &.total-block {\n\t\tmargin-bottom: 30px;\n\t }\n\n\t\t.info-block {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tpadding: 10px 0;\n\t\t\tp {\n\t\t\t\tfont-family: BricolageGrotesque;\n\t\t\t\tcolor:#072633;\n\n\t\t\t\t&.form-label {\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tfont-size: 16px;\n\n\t\t\t\t\t&.total {\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.form-value {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 300;\n\n\t\t\t\t\t&.total{\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n.edit-block {\n\tdisplay: flex;\n\talign-items: end;\n\tgap:12px;\n\tfont-family: BricolageGrotesque;\n\tfont-size: 18px;\n\tfont-weight: 700;\n\tcolor:#072633;\n\n\t.checkout-edit {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tcursor: pointer;\n\t}\n}\n\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
